import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { UserRoles } from '@dynamika-shared/types/auth';
import { PhoneNumberUtil } from 'google-libphonenumber';
const phoneUtil = PhoneNumberUtil.getInstance();

export const userValidationSchema = yupResolver(
  yup.object().shape({
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    email: yup.string().email().required(),
    country: yup.string().nullable(),
    organizationId: yup.string().required(),
    phone: yup
      .string()
      .test('is-phone-valid', 'Invalid phone number', value => {
        if (!value) {
          return true;
        }
        try {
          return phoneUtil.isValidNumber(
            phoneUtil.parseAndKeepRawInput(String(value))
          );
        } catch (e) {
          return false;
        }
      })
      .optional()
      .nullable(),
    roles: yup
      .array()
      .of(yup.string().oneOf(Object.values(UserRoles)))
      .min(1, 'Please select Role Group(s) for the user')
      .test(
        'is-defined',
        'Roles cannot be undefined',
        value => value !== undefined
      )
      .required(),
  })
);
